var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataList"},_vm._l((_vm.dataList),function(item,index){return _c('datas',{key:index,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }